// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WidthBoundary {\n  display: flex;\n}\n\n.WidthBoundary--end {\n  justify-content: end;\n}", "",{"version":3,"sources":["webpack://./src/components/common/WidthBoundary.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".WidthBoundary {\n  display: flex;\n}\n\n.WidthBoundary--end {\n  justify-content: end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
